var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { Grid, InputSearch, Section } from '../../shared';
import { Button } from '../../shared/button/button';
import { EditClient } from '../add-client/edit-client';
import { NoGridData } from '../../../components/shared/grid-no-data/no-grid-data';
import './client-dashboard.scss';
import { useLoader } from '../../../shared/utils';
import { LoaderWrapper } from '../../../shared/utils/loader/loader-wrapper';
import { SelectedClient } from '../../../components/shared/component/selected-client';
import { loaderConstant } from '../../../shared/types/constants';
export var ClientDashboard = function (_a) {
    var clientList = _a.clientList, pageSize = _a.pageSize, formTitles = _a.formTitles, pageFunction = _a.pageFunction, sortFunction = _a.sortFunction, handleKey = _a.handleKey, getRowId = _a.getRowId, fetchClients = _a.fetchClients, noOfExistingClients = _a.noOfExistingClients, refreshClientDetails = _a.refreshClientDetails, handleClickEdit = _a.handleClickEdit, handleCloseEdit = _a.handleCloseEdit;
    var _b = useState(false), showAddClient = _b[0], toggleShowAddClient = _b[1];
    var _c = useState(1), pageCount = _c[0], setPageCount = _c[1];
    var _d = useState(false), modalVisible = _d[0], setModalVisible = _d[1];
    var _e = useState(), clientData = _e[0], setClientData = _e[1];
    var _f = useState(false), isReset = _f[0], setReset = _f[1];
    var _g = useState(0), selectedAnswer = _g[0], setselectedAnswer = _g[1];
    var clientTableIsLoading = useLoader({ identifier: 'clientTable' }).clientTableIsLoading;
    var _h = useState('add'), modalMode = _h[0], setModalMode = _h[1];
    var columns = [
        {
            id: 'id',
            description: 'Id',
            hidden: true,
        },
        {
            id: 'title',
            description: 'Title',
            hidden: true,
        },
        {
            id: 'name',
            description: 'Full name',
            extendClass: 'c-desktop-hide',
            hidden: true,
            render: function (column, row) {
                var _a, _b;
                return React.createElement(React.Fragment, null, "".concat((_a = row === null || row === void 0 ? void 0 : row.firstName) !== null && _a !== void 0 ? _a : '', " ").concat((_b = row === null || row === void 0 ? void 0 : row.surname) !== null && _b !== void 0 ? _b : ''));
            },
        },
        {
            id: 'customerTypeName',
            description: 'Client Type',
        },
        {
            id: 'customerName',
            description: 'Name',
            extendClass: 'c-mobile-hide',
        },
        {
            id: 'companyName',
            description: 'Company Name',
            hidden: true,
            render: function (column, row) {
                return row.customerName;
            },
        },
        {
            id: 'firstName',
            description: 'First name',
            hidden: true,
        },
        {
            id: 'surname',
            description: 'Last name',
            hidden: true,
        },
        {
            id: 'dob',
            description: 'Date of birth',
            extendClass: 'c-mobile-hide',
        },
        {
            id: 'dateOfBirth',
            description: 'Date of birth',
            hidden: true,
            render: function (column, row) {
                var _a;
                var date = new Date(Date.parse((_a = row[column.id]) !== null && _a !== void 0 ? _a : Date.now));
                return (React.createElement(React.Fragment, null,
                    React.createElement("span", null, date.toLocaleDateString())));
            },
        },
        {
            id: 'email',
            description: 'Email',
            extendClass: 'c-mobile-hide',
        },
        {
            id: 'mobileNumber',
            description: 'Telephone',
            extendClass: 'c-mobile-hide',
        },
        {
            id: 'edit',
            description: '',
            render: function (column, row) {
                return (React.createElement(React.Fragment, null, React.createElement(Button, { variant: "secondary", type: "button", onClick: function (e) {
                        showModalEdit(row);
                        handleClickEdit(e);
                    } }, "Edit")));
            },
        },
    ];
    var showModalEdit = function (client) {
        setReset(true);
        setClientData(client);
        setModalVisible(true);
    };
    var hideModal = function () {
        setClientData(null);
        setModalVisible(false);
        handleCloseEdit();
        setModalMode('add');
        setselectedAnswer(0);
    };
    useEffect(function () {
        var _a;
        var count = 1;
        if (clientList && clientList.length > 0)
            count = ((_a = clientList[0]) === null || _a === void 0 ? void 0 : _a.pageCount) || 1;
        setPageCount(count);
    }, [clientList]);
    return (React.createElement(React.Fragment, null,
        React.createElement(EditClient, { show: modalVisible, handleClose: hideModal, modalMode: modalMode, client: __assign(__assign({}, clientData), { companyName: clientData === null || clientData === void 0 ? void 0 : clientData.customerName }), titles: formTitles, fetchCustomers: fetchClients, setToggle: setModalVisible, resetForm: setReset, isReset: isReset, refreshClientDetails: refreshClientDetails, customerTypeId: selectedAnswer }),
        React.createElement(Section, { className: "c-client", headerChildren: React.createElement("div", { className: "c-search-add" },
                !showAddClient && React.createElement(InputSearch, { id: "search-clients", onKeyUp: handleKey }),
                React.createElement("div", null,
                    React.createElement(SelectedClient, { onModalVisibleChange: setModalVisible, onClientDataChange: setClientData, onResetChange: setReset, onSelectedAnswerChange: function (answer) {
                            setModalMode('add');
                            setselectedAnswer(answer);
                        }, selectedAnswer: selectedAnswer }))) },
            React.createElement(LoaderWrapper, { type: "table", identifier: "clientTable" },
                React.createElement(Grid, { rowData: clientTableIsLoading ? [] : clientList, extendClass: "c-client-dashboard__grid", columns: columns, pageSize: pageSize, selectRow: function (row) {
                        setselectedAnswer(row.customerTypeId);
                        setModalMode('edit');
                        getRowId(row.id);
                    }, maxPage: pageCount, gotoPage: pageFunction, sortRows: sortFunction, noRowsMessage: React.createElement(NoGridData, { image: 'no-clients', message: clientTableIsLoading
                            ? loaderConstant.loadingText
                            : noOfExistingClients === 0
                                ? 'You currently have no clients'
                                : 'No matching records found' }), disablePaging: false, defaultSortColumn: "id", defaultDirection: "Desc" })))));
};
